<template>
    <div>
        <div class="row d-flex align-items-center mt-5">
            <div class="col-sm-2">
                <h4>{{ userRole == 'manager' ? 'Menedžeri' : 'Darbinieki' }}</h4>
            </div>
            <div class="d-flex justify-content-end"
                 :class="{'col-sm-5': userRole == 'manager',
                          'col-sm-7': userRole == 'user' }"
                >
                <UserBulkActions v-if="userRole == 'user' && currentUser.isAdmin"></UserBulkActions>
                <button class="ds-btn mr-1" @click="showUserAddModal">Pievienot lietotāju</button>
                <UsersImport v-if="userRole == 'user'"/>
                <UsersExport v-if="userRole == 'user'"/>
            </div>
            <div class="col-sm-3"  v-if="userRole == 'user'">
                <div class="text-center">
                    <input type="text" v-model="searchTerm" placeholder="Meklēt darbiniekus..."
                           class="my-4 px-4 py-2 ds-input">
                </div>
            </div>
        </div>
        <div class="row text-center my-4">
            <div class="col-sm-2 font-weight-bold text-left">Vārds</div>
            <div class="col-sm-4 font-weight-bold text-left">Uzvārds</div>
            <div v-if="currentUser.isAdmin" class="col-sm-1 font-weight-bold text-left">Pagaidu parole</div>
            <div class="font-weight-bold text-right" :class="`col-sm-${currentUser.isAdmin ? '2' : '4' }`">Instruktāžas iziešanas datums</div>
            <div class="col-sm-2 font-weight-bold text-right">Darbības</div>
        </div>
        <div class="col-sm-12" style="max-height: 552px; overflow-x: hidden;">
            <UsersListItem v-for="user in sortedUsers" :user="user" :key="user._id"/>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';

    import UserBulkActions from '@/components/users/UserBulkActions';

    import UsersImport from '@/components/users/UsersImport';
    import UsersExport from '@/components/users/UsersExport';

    import UsersListItem from '@/components/users/UsersListItem';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';
    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';

    export default {
        name: 'users-list',
        components: { UsersImport, UsersExport, UsersListItem, UserBulkActions },
        data: () => ({searchTerm: ''}),
        props: {
            userRole: {
                type: String,
                default: 'user',
            }
        },
        methods: {
            ...mapActions('user', {
                /** @type {function|*} */
                showUserAddModal: userStoreTypes.ACTION_SHOW_MODAL,
            }),
        },
        computed: {
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
            totalRows() {
                return this.currentCompany.users.filter(({role}) => role === this.userRole).length
            },
            sortedUsers() {
                let [sName, sSurname = ''] = this.searchTerm.split(' ')
                let roleFiltered = this.currentCompany.users.filter(({role}) => role === this.userRole)
                .filter(({name, surname}) => !this.searchTerm ? true : `${name} ${surname}`.match(new RegExp(`.*${sName}.*${sSurname}.*`, 'i')))
                let onLongTermLeave = roleFiltered.filter(({isOnLongTermLeave}) => isOnLongTermLeave)
                let notOnLongTermLeave = roleFiltered.filter(({isOnLongTermLeave}) => !isOnLongTermLeave)
                let testsPassed = notOnLongTermLeave.filter(({allTestsPassed}) => allTestsPassed)
                let notPassed = notOnLongTermLeave.filter(({allTestsPassed}) => !allTestsPassed)
                return [...notPassed, ...testsPassed, ...onLongTermLeave]
            }
        }
    }
</script>